<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card elevation="0" min-height="300px">
        <v-form v-model="valid" ref="assignForm">
          <v-card-title>
            Assign Task &nbsp;
            <v-chip color="primary">{{itemId}}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-row no-gutters>
                  <v-textarea
                    v-model="assign.remark"
                    label="Remark"
                    rows="3"
                    prepend-icon="description"
                  />
                </v-row>
                <v-row no-gutters>
                  <v-autocomplete
                    name="employee"
                    v-model="assign.employeeDto.userAccountId"
                    label="Employee *"
                    :rules="employeeRule"
                    autocomplete="off"
                    prepend-icon="person_outline"
                    :items="employee"
                    item-value="userAccountId"
                    item-text="profileName"
                  />
                </v-row>
                <v-alert
      border="left"
      colored-border
      color="red"
      elevation="2"
      v-if="onOffRider==1"
    >
      Please,This Rider is off day to change next Rider.
    </v-alert>
              </v-col>
              <v-col offset-md="1" cols="12" md="4" class="mt-4">
                <v-alert border="left" colored-border color="black" elevation="1">
                  <ul>
                    <li>Date : {{assign.date | formatDateTime($moment)}}</li>
                    <li>ModifiedDate : {{assign.modifiedDate | formatDateTime($moment)}}</li>
                  </ul>
                </v-alert>
                <v-autocomplete
                class="mt-5"
                      v-model="activeUser"
                      item-text="userName"
                      :items="activeUserList"
                      label="Available Rider"
                      autocomplete="off"
                      return-object
                      outlined
                      filled
                    ></v-autocomplete>
                    <v-row no-gutters>
                  <v-col cols="12" md="12">
                        <span class="red--text">
                            Busy : 
                            {{ busy }}
                          </span
                        >
                      </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" md="12">
                        <span class="purple--text">
                            On Way : 
                            {{ onway }}
                          </span
                        >
                      </v-col>
                </v-row>
                    <v-row no-gutters>
                  <v-col cols="12" md="12">
                        <span class="green--text">
                            Free Way : 
                            {{ free }}
                          </span
                        >
                      </v-col>
                </v-row>
                
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="assign.assignId == 0" @click="beforeSaveAssign">
              <v-icon>save</v-icon>Save
            </v-btn>
            <v-btn color="primary" v-else @click="beforeUpdateAssign">
              <v-icon>edit</v-icon>Update
            </v-btn>
            <v-btn color="accent" @click="printPreview"><v-icon>print</v-icon>Print</v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import employeeService from "../service/EmployeeService";
import orderService from "../service/OrderService";
export default {
  mounted: function() {
    orderService.riderStatusList().then((response) => {
        this.rstatus = response;
        if(this.rstatus.busyList != undefined){
          for(let i = 0;i<this.rstatus.busyList.length;i++){
            if(i==0){
               this.busy = this.rstatus.busyList[i];
            }else{
              this.busy = this.busy + ", "+ this.rstatus.busyList[i];
            }
            
          }
        }
        if(this.rstatus.onWayList != undefined){
          for(let i = 0;i<this.rstatus.onWayList.length;i++){
            if(i==0){
               this.onway = this.rstatus.onWayList[i];
            }else{
              this.onway = this.onway + ", "+ this.rstatus.onWayList[i];
            }
            
          }
        }
        if(this.rstatus.freeWayList != undefined){
          for(let i = 0;i<this.rstatus.freeWayList.length;i++){
            if(i==0){
               this.free = this.rstatus.freeWayList[i];
            }else{
              this.free = this.free + ", "+ this.rstatus.freeWayList[i];
            }
            
          }
        }
        
      });
    employeeService.getAllDeliveryForAssign(this.itemId).then(data => {
      this.employee = this.employee.filter(v => false);
      this.employee.push(...data);
      this.loadAssign();
    });
    employeeService.getUserAccountsByTaskUser(this.itemId).then(data => {
      this.activeUserList.push(...data);
      //this.activeUser = this.activeUserList[0];
    });
    
  },
  data: () => {
    return {
      valid: false,
      employee: [],
      employeeRule: [v => !!v || "Employee is required"],
      activeUserList:[],
      activeUser:{},
      rstatus : {},
      free : "",
      onway:"",
      busy:"",
    };
  },
  props: {
    onOffRider:Number,
    itemId: Number,
    assign: {
      itemId: {
        type: Number,
        default: 0
      },
      assignId: {
        type: Number,
        default: 0
      },
      employeeDto: {
        type: Object,
        default: {
          userAccountId: {
            type: Number,
            default: 0
          }
        }
      },
      remark: {
        type: String,
        default: ""
      },
      date: {
        type: String,
        default: ""
      },
      modifiedDate: {
        type: String,
        default: ""
      }
    },
    loadAssign: Function,
    saveAssign: Function,
    updateAssign: Function
  },
  methods: {
    
    printPreview: function(){
      this.$router
          .push({
            name: "voucherPrint",
            query: {
              itemId: this.itemId,
            }
          })
          .catch(() => {});
    },
    beforeSaveAssign: function() {
      this.$refs.assignForm.validate();
      if (this.valid) {
        this.saveAssign();
      }
    },
    beforeUpdateAssign: function() {
      this.$refs.assignForm.validate();
      if (this.valid) {
        this.updateAssign();
      }
    },
    getAllDeliveryForAssign: function() {
      employeeService.getAllDeliveryForAssign(this.itemId).then(data => {
        this.employee = this.employee.filter(v => false);
        this.employee.push(...data);
        this.loadAssign();
      });
    }
  },
  watch:{
    activeUser:function(){
        this.assign.employeeDto.userAccountId = this.activeUser.userAccountId;
    }
  }
};
</script>

<style scoped>
.login-full {
  height: 81vh;
}
</style>